import { Button } from "@altimateai/lego";
import styles from "./styles.module.scss";
import NoIntegrationImage from "@/assets/images/no_channel.svg";
import { isOwner } from "@/services/auth";

interface NoIntegrationProps {
  toggleAddIntegration: () => void;
  disabled: boolean;
  hideAddButton: boolean;
}

export const NoIntegration = ({
  toggleAddIntegration,
  disabled,
  hideAddButton,
}: NoIntegrationProps) => {
  return (
    <div className={styles.no_integration} role="region" aria-label="No integration state">
      <img src={NoIntegrationImage} alt="no_integration" />
      <div className={styles.title}>No integration found</div>
      <div className={styles.subtitle}>Add integration</div>
      {isOwner() && !hideAddButton ? (
        <Button className={styles.button} onClick={toggleAddIntegration} disabled={disabled}>
          Add Integration
        </Button>
      ) : null}
    </div>
  );
};
